/*eslint array-callback-return: ["off"]*/

import React from 'react';

import AlarmIcon from '../../../../../common/icons/AlarmIcon';

import { Row, Col, Popover, Tooltip, Tag } from 'antd';

export default translationsStore => ({
  width: '75px',
  align: 'center',
  title: translationsStore.translate('lead.table.column.alarms'),
  dataIndex: 'alarms',
  className: 'alarms',
  render: (text, record) => {
    if (record.alarms.length === 0) {
      return <span>&mdash;</span>;
    }
    return (
      <Row>
        {record.alarms.map((alarm, index) => {
          if (index === 1) {
            return (
              <Col key={index}>
                <Popover
                  trigger="click"
                  getPopupContainer={() => document.getElementById(`Leads`)}
                  content={
                    <Row>
                      {record.alarms.map((alarm, index) => {
                        if (index > 0) {
                          return (
                            <Col key={index} style={{ display: 'flex', alignItems: 'center' }}>
                              <div style={{ display: 'flex', alignItems: 'center', width: '40px', height: '28px', justifyContent: 'center' }}>
                                <AlarmIcon type={alarm.code} style={{ fontWeight: '400', fontSize: '0.8rem' }} />
                              </div>
                              <div>{alarm.description}</div>
                            </Col>
                          );
                        }
                      })}
                    </Row>
                  }
                >
                  <Tag style={{ marginRight: 0 }}>{'+' + (record.alarms.length - 1)}</Tag>
                </Popover>
              </Col>
            );
          }
          if (index === 0) {
            return (
              <Col key={index}>
                <Tooltip title={alarm.description} placement="right">
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '25px' }}>
                    <AlarmIcon type={alarm.code} style={{ fontWeight: '400', fontSize: '0.8rem' }} />
                  </div>
                </Tooltip>
              </Col>
            );
          }
        })}
      </Row>
    );
  }
});
